import React, { useEffect } from "react";
import Header from "../components/header/Header";
import { Navigate, useLocation } from "react-router-dom";
import { state } from "../redux/util/getStore";

const ProtectRoute = ({ children, isAccessToken = false }) => {
  const aToken = state("AccessToken");
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  console.log("Access Token", aToken, isAccessToken);

  // if (isAccessToken) {
  if (aToken !== null && Object.keys(aToken)?.length != 0) {
    return <Header children={children} />;
  } else {
    return <Navigate to={"/login"} />;
  }
  // } else {
  //     return (
  //         <>
  //             <Header children={children} />
  //             {/* <div className="bg-blue h-full p-6">
  //                 {children}
  //             </div> */}

  //         </>
  //     );
  // }

  // if (isAccessToken) {
  //   if (aToken && Object.keys(aToken || {})?.length !== 0) {
  //     return <Header children={children} />;
  //   } else {
  //     return <Navigate to="/login" />;
  //   }
  // } else {
  //   return (
  //     <>
  //       <Header children={children} />
  //     </>
  //   );
  // }
};

export default ProtectRoute;
